import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';

@Injectable()


 export class Config {
    private config: any;
    private env: any;

    constructor(
        private http: HttpClient
    ) {
    }


    load(configPath) {
        return new Promise((resolve, reject) => {
            if (configPath && configPath.trim() !== '') {
                this.http.get(configPath)
                .pipe(map(res => res))
                .subscribe(
                    res => {
                        this.config = res;
                        resolve(res);
                    },
                    error => {
                        if (environment && environment !== null) {
                            this.config = environment;
                            resolve(environment);
                        } else {
                            reject('Server error');
                        }
                    }
                );
            } else {
                if (environment && environment !== null) {
                    this.config = environment;
                    resolve(environment);
                } else {
                    reject('Server error');
                }
            }
        });
    }


    get(key: any) {
        return this.config[key];
    }

    getEndPoint(obj: any, page_id: string, api_id: string) {
        let result: any;
            if (obj['view_id'] === page_id) {
                if (obj['apiEndPoints'].length > 0) {
                    for (const apiObj of obj['apiEndPoints']) {
                        if (apiObj['api_id'] === api_id) {
                            if (apiObj.url !== '') {
                                return apiObj.url;
                            } else {
                                return 'false';
                            }
                        }
                    }
                } else {
                    return 'false';
                }
            } else {
                if (obj['subPages']) {
                    for (let i = 0; i < obj['subPages'].length; i += 1) {
                        result = this.getEndPoint(obj['subPages'][i], page_id, api_id);
                        if (result !== 'false') {
                            return result;
                        }
                    }
                    return 'false';
                } else {
                    return 'false';
                }
            }
    }

    getButtons(obj: any, page_id: string) {
        let result: any;

            if (obj['view_id'] === page_id) {
                if (obj.hasOwnProperty('buttons') && obj['buttons'].length > 0) {
                    return obj['buttons'];
                } else {
                    return  'false';
                }
            } else {
                if (obj['subPages']) {
                    for (let i = 0; i < obj['subPages'].length; i += 1) {
                        result = this.getButtons(obj['subPages'][i], page_id);
                        if (result !== 'false') {
                            return result;
                        }
                    }
                    return  'false';
                } else {
                    return  'false';
                }
            }
    }

    getHeaders(obj: any, page_id: string) {
        let result: any;
            if (obj['view_id'] === page_id) {
                if (obj.hasOwnProperty('headers') && obj['headers'].length > 0) {
                    return obj['headers'];
                } else {
                    return 'false';
                }
            } else {
                if (obj['subPages']) {
                    for (let i = 0; i < obj['subPages'].length; i += 1) {
                        result = this.getHeaders(obj['subPages'][i], page_id);
                        if (result !== 'false') {
                            return result;
                        }
                    }
                    return 'false';
                } else {
                    return 'false';
                }
            }
    }

    getFilters(obj: any, page_id: string) {
        let result: any;
            if (obj['view_id'] === page_id) {
                if (obj.hasOwnProperty('filters') && obj['filters'].length > 0) {
                    return obj['filters'];
                } else {
                    return 'false';
                }
            } else {
                if (obj['subPages']) {
                    for (let i = 0; i < obj['subPages'].length; i += 1) {
                        result = this.getFilters(obj['subPages'][i], page_id);
                        if (result !== 'false') {
                            return result;
                        }
                    }
                    return 'false';
                } else {
                    return 'false';
                }
            }
    }
    getKeyInView(obj: any, page_id: string, key: string) {
        let result: any;
            if (obj['view_id'] === page_id) {
                if (obj.hasOwnProperty(key)) {
                    return obj[key];
                } else {
                    return 'false';
                }
            } else {
                if (obj['subPages']) {
                    for (let i = 0; i < obj['subPages'].length; i += 1) {
                        result = this.getKeyInView(obj['subPages'][i], page_id, key);
                        if (result !== 'false') {
                            return result;
                        }
                    }
                    return 'false';
                } else {
                    return 'false';
                }
            }
    }

}
